import React from 'react';

export default class VideoModal extends React.Component {

    constructor(props) {
        super(props);

        this.events = {
            open: 'modal.youtube.open.'+props.id,
            //close: 'modal.youtube.close.'+props.id,
            //toggle: 'modal.youtube.toggle.'+props.id,
        }

        this.state = {
            open: false
        }

        this.EventManager = window.app.eventManager;
        this.EventManager.createEvent(this.events.open, 'Youtube open modal for '+props.id, 'This event is triggered when you want to open the relevant youtube modal', this);
        //this.EventManager.createEvent(this.events.close, 'Youtube close modal for '+props.id, 'This event is triggered when you want to close the relevant youtube modal', this);
        //this.EventManager.createEvent(this.events.toggle, 'Youtube toggle modal for '+props.id, 'This event is triggered when you want to close/open the relevant youtube modal', this);
    }

    componentDidMount() {
        this.EventManager.subscribe(this.events.open, (e) => {
            this.toggle(true);
        });
        /*this.EventManager.subscribe(this.events.close, (e) => {
            this.toggle(false);
        });
        this.EventManager.subscribe(this.events.toggle, (e) => {
            this.toggle();
        });*/
    }

    toggle = (open = null) => {
        open = (open !== null) ? open : !this.state.open;
        this.setState({open: open});
    }

    render() {
        let classname = 'modal-shroud' + (this.state.open ? '' : 'hidden');
        if(!this.state.open) return <></>;

        return (
            <div className={classname} onClick={ () => { this.toggle(false) }}>
                <div className="modal video-modal">
                    <iframe src={`https://www.youtube-nocookie.com/embed/${this.props.videoId}?rel=0&autoplay=1`} allowFullScreen></iframe>
                    <button className="modal-close" onClick={ () => { this.toggle(false) }}>×</button>
                </div>
            </div>
        )
    }
};
